// Replaces AuditLog
export var OrganisationLogEventType;
(function (OrganisationLogEventType) {
    OrganisationLogEventType["CREATED"] = "created";
    OrganisationLogEventType["UPDATED"] = "updated";
    /** When things happen to the org itself, like disconnects. Never purge this */
    OrganisationLogEventType["ORGANISATION_EVENT"] = "organisation_event";
})(OrganisationLogEventType || (OrganisationLogEventType = {}));
export var OrganisationLogResourceType;
(function (OrganisationLogResourceType) {
    OrganisationLogResourceType["INVOICE"] = "invoice";
    OrganisationLogResourceType["CONTACT"] = "contact";
    OrganisationLogResourceType["QUOTE"] = "quote";
    /** When things happen to the org itself, like disconnects. Never purge this */
    OrganisationLogResourceType["ORGANISATION"] = "organisation";
})(OrganisationLogResourceType || (OrganisationLogResourceType = {}));
// TODO - move to lifecycle event
export var OrganisationDisconnectMethods;
(function (OrganisationDisconnectMethods) {
    /** When the user disconnects by clicking the disconnect button in app */
    OrganisationDisconnectMethods["IN_APP"] = "in_app";
    /** When the orgs disconnects due us. E.g no subscription */
    OrganisationDisconnectMethods["PAIDNICE_PURGE"] = "paidnice_purge";
    /** When we disconnect due to incoming webhooks but marked as disconnected already */
    OrganisationDisconnectMethods["DISCONNECTED_LOCALLY"] = "disconnected_locally";
})(OrganisationDisconnectMethods || (OrganisationDisconnectMethods = {}));
//# sourceMappingURL=organisationLog.js.map